export default "__VITE_ASSET__B2NKYUrB__"